import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMAGES } from "@/lib/site-data";
import { SectionHeading } from "@/components/SectionHeading";

const SPANS = [
  "md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7",
  "md:col-span-4", "md:col-span-4", "md:col-span-4",
  "md:col-span-4", "md:col-span-4", "md:col-span-4",
  "md:col-span-12",
];

export const Products = () => (
  <section id="leistungen" data-testid="products-section" className="bg-[#f6f5f2] py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-wrap items-end justify-between gap-8 mb-14">
        <SectionHeading
          testid="products"
          eyebrow="Leistungen"
          title="Bauelemente, die Maßstäbe setzen."
          text="Elf Produktwelten – ein Anspruch: beste Verarbeitung, Anthrazit als Statement und Montage nach RAL-Standard. Ihr persönliches Angebot erhalten Sie innerhalb von 24 Stunden."
        />
      </div>

      <div data-testid="products-grid" className="grid grid-cols-1 md:grid-cols-12 gap-5">
        {IMAGES.products.map((p, i) => (
          <motion.a
            key={p.name}
            href="#kontakt"
            data-testid={`product-card-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className={`group relative overflow-hidden rounded-2xl bg-[#e9e7e2] ${SPANS[i]} ${i === 10 ? "h-64 sm:h-72" : "h-80 sm:h-96"}`}
          >
            <img
              src={p.img}
              alt={p.name}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#14171a]/85 via-transparent to-transparent" />
            <span className="absolute top-5 left-6 font-display text-white/50 text-sm tracking-widest font-medium">
              {String(i + 1).padStart(2, "0")}
            </span>
            <div className="absolute bottom-0 inset-x-0 p-6 sm:p-7 flex items-end justify-between gap-4">
              <div>
                <h3 className="font-display font-semibold text-white text-xl sm:text-2xl">{p.name}</h3>
                <p className="text-white/65 text-sm mt-1.5 max-w-md">{p.desc}</p>
              </div>
              <span className="shrink-0 w-11 h-11 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-white transition-colors duration-300 group-hover:bg-[#e2001a] group-hover:border-[#e2001a]">
                <ArrowUpRight size={17} />
              </span>
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);
